import React, { useCallback } from "react";
import DepartureInfos from "./forms/DepartureInfos";
import DeparturePreparation from "./forms/DeparturePreparation";
import DepartureDelivery from "./forms/DepartureDelivery";
import DepartureReception from "./forms/DepartureReception";
import DepartureAttachments from "./forms/DepartureAttachments";
import Comments from "./forms/DepartureComments";
import DepartureInvoice from "./forms/DepartureInvoice";

const DepartureForms = ({ activeTab, forms, setForms }) => {
  const handleFormChange = useCallback(
    (name, formData) => {
      setForms({ ...forms, [name]: formData });
    },
    [forms, setForms]
  );
  switch (activeTab) {
    case "General infos":
      return <DepartureInfos />;
    case "Preparation":
      return <DeparturePreparation />;
    case "Delivery":
      return <DepartureDelivery />;
    case "Reception":
      return <DepartureReception />;
    case "Attachments":
      return <DepartureAttachments />;
    case "Exchange":
      return <Comments />;
    case "Invoice":
      return <DepartureInvoice />;

    default:
      break;
  }
};

export default DepartureForms;
